'use client';

import {
    type Control,
    Controller,
    type FieldValues,
    type Path,
    useFormState,
} from 'react-hook-form';
import { PasswordInput, type PasswordInputProps } from './password-input';

interface ControlledPasswordInputProps<T extends FieldValues>
    extends PasswordInputProps {
    control: Control<T>;
    name: Path<T>;
}

export function ControlledPasswordInput<T extends FieldValues>({
    control,
    name,
    ...props
}: ControlledPasswordInputProps<T>) {
    const { errors } = useFormState({ control, name });

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <PasswordInput
                    {...field}
                    errorMessage={errors[name]?.message as string}
                    isInvalid={!!errors[name]}
                    {...props}
                />
            )}
        />
    );
}
